import { render, staticRenderFns } from "./HouseholdTabs.vue?vue&type=template&id=7ecd8490&"
import script from "./HouseholdTabs.vue?vue&type=script&lang=js&"
export * from "./HouseholdTabs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports